import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

const AuthenticatedRoute: React.FC<{ children: JSX.Element }> = ({
    children,
}) => {
    const token = useSelector((state: RootState) => state.auth.token);

    // Use React Router's location context, not window.location
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    const redirectToParam = urlParams.get('redirectTo') || '/book-library';

    // Only allow paths that start with "/" to avoid open redirects
    const safeRedirectTo = redirectToParam.startsWith('/')
        ? redirectToParam
        : '/book-library';

    if (token || process.env.REACT_APP_INSTALLATION_MODE === 'desktop') {
        return <Navigate to={safeRedirectTo} replace />;
    }

    return children;
};

export default AuthenticatedRoute;
